export enum Department {
    WealthService = 'WealthService',
    HumanResources = 'HumanResources',
    BusinessIntelligence = 'BusinessIntelligence',
    Asset = 'Asset',
    BackRvd = 'BackRvd',
    PerformanceAndProjects = 'PerformanceAndProjects',
    Ipo = 'Ipos',
    Cambio = 'Cambio',
    FinancialPlanning = 'FinancialPlanning',
    Consolidation = 'Consolidation',
}
